
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/auth",
      function () {
        return require("private-next-pages/auth.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/auth"])
      });
    }
  